export enum Roles {
    ADMIN = 1,
    SUPERVISOR = 2,
    AGENT = 3,
    STORE = 4,
    GERENT = 5,
    SUPPORT = 6,
    AUDIT = 7,
    PARTNER = 8
}